// searchFields.js
export const SEARCH_FIELDS = [
  { label: "GRN ID", value: "grnId" },
  { label: "PO Number", value: "ponumber" }, // 👈 MUST match your data key
  { label: "Supplier Code", value: "suprefcode" },
  { label: "Supplier Name", value: "suppliername" },

];
export const SEARCH_FIELDS_GRNHISTORY = [

  { label: "GRN ID", value: "grnId" },
  { label: "PO Number", value: "ponumber" }, // 👈 MUST match your data key
  { label: "Supplier Code", value: "suprefcode" },
  { label: "Supplier Name", value: "suppliername" },
  { label: "Invoice Number", value: "invoiceno" },
];

export const SEARCH_FIELDS_RTNHISTORY = [
   { label: "Purchase Return No", value: "grnreturncode" },
    { label: "PO Number", value: "ponumber" }, // 👈 MUST match your data key
      { label: "Invoice Number", value: "invoiceno" },
  { label: "GRN ID", value: "grnId" },

  { label: "Supplier Code", value: "suprefcode" },
  { label: "Supplier Name", value: "suppliername" },
   { label: "Debit Note Number", value: "debitNoteNumber" },
  { label: "Batch Number", value: "batchNumber" },
  { label: "Return ID", value: "RETURNID" },
];

export const SEARCH_FIELDS_MYACTIONS = [
 
  { label: "GRN ID", value: "grnId" },

  { label: "Supplier Code", value: "suprefcode" },
  { label: "Supplier Name", value: "suppliername" },

  { label: "Return ID", value: "RETURNID" },
];
